import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAdmin } from '../utils/authHelpers';

const AdminRoute = ({ children }) => {
    return isAdmin() ? children : <Navigate to="/admin/login" replace />;
};

export default AdminRoute;